import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RichUtils } from 'draft-js';
import IconButton from '@material-ui/core/IconButton';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    color: 'white',
  },
});

const createInlineStyleButton = ({ inlineStyle, children }) =>
  @withStyles(styles)
  class InlineStyleButton extends Component {
    static serviceName = 'inlineStyleButton';
    static inlineStyle = inlineStyle;
    static displayName = `InlineStyleButton-${inlineStyle}`;

    static propTypes = {
      setEditorState: PropTypes.func.isRequired,
      editorState: PropTypes.object.isRequired,
    };

    get isActive() {
      return this.props.editorState.getCurrentInlineStyle().has(inlineStyle);
    }

    preventDefault(e) {
      e.preventDefault();
    }

    toggleStyle = e => {
      e.preventDefault();
      this.props.setEditorState(
        RichUtils.toggleInlineStyle(this.props.editorState, inlineStyle),
      );
    };

    render() {
      const { classes } = this.props;

      return (
        <div className={classes.root} onMouseDown={this.preventDefault}>
          <IconButton
            onClick={this.toggleStyle}
            color={this.isActive ? 'primary' : 'inherit'}
          >
            {children}
          </IconButton>
        </div>
      );
    }
  };

export default createInlineStyleButton;
